import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICourse, ICourseInitialState } from "./courseModel";
import {
  ActiveInactiveCourse,
  CourseImageUpload,
  createCourse,
  deleteCourse,
  getAllActiveCourse,
  getAllCourse,
  getCourseByID,
  updateCourse,
} from "./services/course.services";

const initialState: ICourseInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  CourseID: null,
  CourseList: [],
  CourseDetail: {
    ID: null,
    Title: "",
    Description: "",
    Logo: "",
    URL: "",
    IsActive: 1,
  },
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    clearCourseDetails: (state) => {
      state.CourseDetail = initialState.CourseDetail;
    },
    setCourseID: (state, action) => {
      state.CourseID = action.payload;
    },
    clearCourseID: (state) => {
      state.CourseID = initialState.CourseID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCourse.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCourse.fulfilled,
      (state, action: PayloadAction<ICourse[]>) => {
        state.loading = false;
        state.CourseList = action.payload || [];
      }
    );
    builder.addCase(getAllCourse.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CourseList = [];
    });
    builder.addCase(createCourse.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createCourse.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createCourse.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCourse.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(updateCourse.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCourse.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCourse.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCourse.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCourse.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCourseByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCourseByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CourseDetail = action.payload;
    });
    builder.addCase(getCourseByID.rejected, (state, action) => {
      state.loading = false;
      state.CourseDetail = initialState.CourseDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCourse.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCourse.fulfilled,
      (state, action: PayloadAction<ICourse[]>) => {
        state.loading = false;
        state.CourseList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCourse.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CourseList = [];
    });
    builder.addCase(ActiveInactiveCourse.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCourse.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCourse.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(CourseImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(CourseImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CourseImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCourseDetails, clearCourseID, setCourseID } =
  courseSlice.actions;
export default courseSlice.reducer;
